import crypto from "crypto-js";

export function generateSEKAndHash(token: any) {
  const iv = "9MSkKLOhJcWselB5";
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = {};
    if (token === "" || token === null || token === undefined) {
      dataPayload = {
        // authorization: `Bearer `,
        appkey: new Date().toISOString(),
        "x-portal": "admin",
      };
    } else {
      dataPayload = {
        authorization: `Bearer ${token}`,
        appkey: new Date().toISOString(),
        "x-portal": "admin",
      };
    }
    const appkey = JSON.stringify(dataPayload);
    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}

export function generateEncryptedKeyBody(body: any) {
  const iv = "9MSkKLOhJcWselB5";
  try {
    const key = crypto.lib.WordArray.random(32);
    const dataPayload = JSON.stringify(body);

    const encrypted = crypto.AES.encrypt(dataPayload, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
